import styled from 'styled-components'

export const SidebarBtnEdit = styled.button`
    cursor: pointer;
    background: none;
    outline: none;
    border: none;
    color: #808080;
    transition: all 0.5s ease-in-out;

    :hover {
        color: #000;
    }
`